import React, { useEffect, useState } from "react";
import { shape, func } from "prop-types";
import { withRouter } from "react-router-dom";
import { Grid} from "@material-ui/core";
import { useMutation, useQuery } from '@apollo/react-hooks';
import Alert from '@material-ui/lab/Alert'
import CourseCard from "../../components/CourseCard";
import gql from 'graphql-tag';
import GlobalContext from "../../context";
import { Linha, Title , ContainerList, TitlePage, Container} from "./styles";
import ReactHtmlParser from 'react-html-parser';
import AppBarWrapper from "../../components/AppBarWrapper";
import Footer from "../../components/Footer";

export const GET_TERMS = gql`
  query {
    getTermsPrivacy {
      id
      text
    }
  }
`;


const Privacidade = ({ history }) => {

  const {data: dataTermos, loading} = useQuery(GET_TERMS, {
    onCompleted: e => {
      console.log(dataTermos.getTermsPrivacy[0])
    }
  })

  return (
    <div>
    <AppBarWrapper/>
      <Container maxWidth="md" style={{height:"100%", backgroundColor: "#080808"}}>

      <ContainerList>
      <TitlePage>
        <strong>
          Termos de Privacidade
        </strong>
        </TitlePage>

       </ContainerList>
       </Container>
       <Container style={{height:"100vh", padding: '0 10% 0 10%',}}>
       <div>
          { ReactHtmlParser (dataTermos.getTermsPrivacy ? dataTermos?.getTermsPrivacy[0]?.text : null)}
        </div>

       </Container>
    <Footer/>
    </div>
  );
};

Privacidade.propTypes = {
  history: shape({
    push: func,
  }).isRequired,
};

export default withRouter(Privacidade);
